/**
 * ViewToggle Component
 * Allows switching between list, cards, and text views
 */

import React from 'react';
import clsx from 'clsx';
import type { ViewToggleProps } from './types';

const viewIcons = {
  list: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  cards: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="2" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="11" y="2" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="2" y="11" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="11" y="11" width="7" height="7" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  text: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 5h14M3 9h10M3 13h14M3 17h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
};

const viewLabels = {
  list: 'Lista',
  cards: 'Tarjetas',
  text: 'Texto',
};

export const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  availableViews,
  onChange,
  disabled = false,
}) => {
  if (availableViews.length <= 1) {
    return null; // Don't show toggle if only one view is available
  }

  return (
    <div className="ai360-view-toggle">
      {availableViews.map((view) => (
        <button
          key={view}
          type="button"
          className={clsx(
            'ai360-view-toggle-button',
            currentView === view && 'ai360-view-toggle-button--active',
            disabled && 'ai360-view-toggle-button--disabled'
          )}
          onClick={() => !disabled && onChange(view)}
          disabled={disabled}
          title={viewLabels[view]}
          aria-label={viewLabels[view]}
        >
          {viewIcons[view]}
          <span className="ai360-view-toggle-label">{viewLabels[view]}</span>
        </button>
      ))}
    </div>
  );
};
